import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsFillReplyAllFill, BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { tipu, msOfficeBg } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import Bonus from "../../components/pageProps/Bonus";

const MsOffice = () => {
  // ================ Course Module start here ==================
  const [showbMsExcel, setShowbMsExcel] = useState(true);
  const [showbPowerPoint, setShowbPowerPoint] = useState(false);
  const [showbMsWord, setShowbMsWord] = useState(false);
  const [showaMsExcel, setShowaMsExcel] = useState(false);
  const [showaPowerPoint, setShowaPowerPoint] = useState(false);
  const [showaMsWord, setShowaMsWord] = useState(false);
  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>MS Office - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Microsoft Office" />
      <div className="max-w-screen-xl mx-auto pb-4 pt-2 px-4 flex flex-col lgl:flex-row items-start xl:gap-10 justify-between">
        <div className="w-full flex flex-col gap-4 md:gap-10">
          <CoursesIntro
            intro="Introduction"
            des=" Currently, the job market is very competitive. So, to sustain
              yourself, there is no alternative to extra Skill. Microsoft Office
              is very important among them. So, keep yourself ahead by becoming
              an expert in Microsoft Excel, Microsoft Word, and Microsoft
              PowerPoint."
            instructorName="Masud Parvej Tipu"
            instructorTitle="Sr. Instructor, English"
            instructorImg={tipu}
            classTitle="Total Class"
            classNo="15"
            langClubTitle="Examination"
            debate="Project"
            supportTitle="SUPPORT"
            support="24/7"
            bg={msOfficeBg}
          />
          {/* =====================================================
                        Course overview start here
           ===================================================== */}
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why Microsoft Office course is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Those who are unable to submit university assignments due to
                    a lack of Microsoft Office skills.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Despite having good content, those who lack Microsoft Office
                    skills are unable to present.
                  </li>
                  <li className="courseModuleListliTwo">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Professionals who want to work faster by utilizing the three
                    most used MS Office software effectively.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* =====================================================
                        Course overview end here
           ===================================================== */}
          {/* =====================================================
                        Course MODULE start here
           ===================================================== */}

          {/* ================================= Basic part start here =================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Materials : BASIC
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== MS Excel Start here ============== */}
            <div>
              <h3
                onClick={() => setShowbMsExcel(!showbMsExcel)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Microsoft Excel :
                {showbMsExcel ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showbMsExcel && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Application Installation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Application Overview.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Worksheet & Workbook.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Row & Column Management.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Data Input.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Data Formatting.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Data Plotting.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Printing & Page Setup.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Illustration.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Media Management.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Primary Function.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        VLOOKUP & HLOOKUP.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Conditional Formation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Graph Management.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Logic Function.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Date & Time Function.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Lookup & Reference Function.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Pivot Table.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Copy Paste Management.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Hyperlink.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* ===============================================================
                                     Powerpoint Start here 
              ============================================================== */}
            <div>
              <h3
                onClick={() => setShowbPowerPoint(!showbPowerPoint)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Microsoft PowerPoint :
                {showbPowerPoint ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showbPowerPoint && (
                <>
                  {/* ================= Introduction start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Introduction :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          User Interface.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          File Management.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Introduction end here ======================= */}
                  {/* ================= Creating Presentation start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Creating Presentation :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Adding Text Using Outline View.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Adding Slides.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Creating Presentation end here ======================= */}
                  {/* ================= Images start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Creating Presentation :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Getting Images.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Placing Images.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Adjusting/Styling Images.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Images end here ======================= */}
                  {/* ================= SmartArt start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Creating Presentation :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Building Diagrams.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Styling Diagrams.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Converting Bullet Lists to SmartArt.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= SmartArt end here ======================= */}
                  {/* ================= Shapes start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Shapes :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Creating Shapes.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Styling Shapes.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Adding Text to Shapes.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Adjusting Shapes.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Text Boxes.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Connectors.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Shapes end here ======================= */}
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* ===============================================================
                                     Powerpoint end here 
              ============================================================== */}
            {/* ===============================================================
                                     Microsoft Word Start here 
              ============================================================== */}
            <div>
              <h3
                onClick={() => setShowbMsWord(!showbMsWord)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Microsoft Word :
                {showbMsWord ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showbMsWord && (
                <>
                  {/* ================= Working with Documents start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Working with Documents :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Create a new document.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Save or, renaming documents.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Working on multiple documents.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Working with Documents end here ======================= */}
                  {/* ================= Editing a Documents start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Editing a Documents :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Typing & inserting text.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          • Rearranging/deleting blocks of text.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Search & replace text.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Formatting Text start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Formatting Text :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Styles.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Changing font, size & style.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Changing text color & highlight text.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Formatting Text end here ======================= */}
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* ===============================================================
                                     Microsoft Word end here 
              ============================================================== */}
          </div>
          {/* ================================= Basic part end here =================================== */}
          {/* ================================= Advance part start here =================================== */}
          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Materials : ADVANCE
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== MS Excel Start here ============== */}
            <div>
              <h3
                onClick={() => setShowaMsExcel(!showaMsExcel)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Microsoft Excel :
                {showaMsExcel ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showaMsExcel && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Data Formatting.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Joint Formula.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Slicer.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Charts Management.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Text Separator.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Validation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Magic Paste.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Math function.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Analysis.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Macro Basic.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Dashboard Development.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* ===============================================================
                                     Powerpoint Start here 
              ============================================================== */}
            <div>
              <h3
                onClick={() => setShowaPowerPoint(!showaPowerPoint)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Microsoft PowerPoint :
                {showaPowerPoint ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showaPowerPoint && (
                <>
                  {/* ================= Layered Objects start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Layered Objects :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Aligning.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Distributing.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Grouping.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Layered Objects end here ======================= */}
                  {/* ================= Tables start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Creating Presentation :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Creating Tables.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Designing Tables.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Tables end here ======================= */}
                  {/* ================= Charts start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Charts :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Creating Charts.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Designing Charts.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Saving Chart Templates.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Charts end here ======================= */}
                  {/* ================= Proofing and Editing start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Proofing and Editing :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Spell Check.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Using Slide Sorter View.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Printing.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Proofing and Editing end here ======================= */}
                  {/* ================= Animation start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Animation :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Slide Transitions.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Slide Animations.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Animation end here ======================= */}
                  {/* ================= Running a Presentation start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Running a Presentation :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Starting and Stopping a Presentation.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Presenting to an Audience.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Navigating.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Annotating.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Using Speaker Notes.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Using Presenter View.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Running a Presentation end here ======================= */}
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* ===============================================================
                                     Powerpoint end here 
              ============================================================== */}
            {/* ===============================================================
                                     Microsoft Word Start here 
              ============================================================== */}
            <div>
              <h3
                onClick={() => setShowaMsWord(!showaMsWord)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Microsoft Word :
                {showaMsWord ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showaMsWord && (
                <>
                  {/* ================= Graphics start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Graphics :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Symbols & character.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Equations.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Illustrations, pictures & smart art.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Watermarks.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Graphics end here ======================= */}
                  {/* ================= Page Formatting start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Page Formatting :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Page margins & orientations.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Apply for page border & color.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Insert headers & footers.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Insert a cover page.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Formatting Paragraph start here ======================= */}
                  <div>
                    <p className="font-titleFont font-semibold text-[16px] underline underline-offset-4 pt-2 text-primeColor">
                      Formatting Paragraph :
                    </p>
                    <div className="w-full flex justify-start items-center">
                      <ul className="ulListModule">
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Change paragraph alignment.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Add border & shading.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Create links.
                        </li>
                        <li className="courseModuleListli">
                          <span className="courseModuleListliSpan">
                            <BsDash />
                          </span>
                          Change space between line & paragraph.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* ================= Formatting Paragraph end here ======================= */}
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* ===============================================================
                                     Microsoft Word end here 
              ============================================================== */}
          </div>
          <div>
            <Bonus
              bonus="We will provide you the sample template desired."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* ================================= Advance part end here =================================== */}

          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
        </div>
      </div>
    </div>
  );
};

export default MsOffice;
